import { DashboardCompliance } from '../../components/dashboard/compliance';
import DashboardOverview from '../../components/dashboard/overview';
import { DashboardPrediction } from '../../components/dashboard/prediction';
import { BasicTabView } from '../../utilities/tab';

const tab = [
  {
    id: 1,
    tabTitle: "Overview",
    tabContent: <DashboardOverview />,
  },

  {
    id: 2,
    tabTitle: "Compliance Report",
    tabContent: <DashboardCompliance />,
  },
  {
    id: 3,
    tabTitle: "Service Prediction",
    tabContent: <DashboardPrediction />,
  },
];

const Dashboard = () => {
  return <BasicTabView tabPanel={tab} width={'100%'} scrollContent />;
};

export default Dashboard;
